import * as publicLocale from './public';
import * as privateLocale from './private';

import global from './global.json';

const ja = { ...publicLocale, ...privateLocale, global };

export { ja };
